import { Fragment } from "react"
import Confirmation from "../components/confirmation/Confirmation"
import RequestEmailForm from "../components/forms/RequestEmailForm"
import useHttp from "../hooks/use-http"
import { requestResetPassword } from "../lib/user-api"


const ForgotPassword = () => {

    const {
        sendRequest,
        error,
        status
    } = useHttp(requestResetPassword);

    const resetPwRequest = (email) => {
        sendRequest({
            email: email
        });
    }

    if (error) {
        return <div className="text-white font-elight text-lg">Something went wrong</div>
    }

    return (
        <Fragment>
            {status !== 'completed' && (
                <RequestEmailForm
                    title={'Reset Password'}
                    buttonMsg={'Reset Password'}
                    onSubmit={resetPwRequest}
                />
            )}
            {status === 'completed' && (
                <Confirmation
                    title={'Reset Request Sent'}
                    msg={'Follow the steps provided in the email we sent you to reset your password.'}
                    isLoading={false}
                    error={false}
                    isActivation={false}
                />
            )}
        </Fragment>
    )
}

export default ForgotPassword;